<template lang="html">
  <div>
      <h1>This is the admin page</h1>
      <ul>
          <li v-for="user in email_list">
              {{ user.name }} || {{ user.email }} || {{ user.status }}
          </li>
      </ul>
  </div>
</template>

<script>
import { db } from '../../store/firebase';
let email_list_ref = db.ref('emailList');

export default {
    firebase: {
        email_list: email_list_ref
    }
}
</script>

<style lang="scss" scoped>
    h1 {
        color: black;
    }
</style>



// WEBPACK FOOTER //
// Admin.vue?38ed2769